import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input, NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  AfterViewInit,
  Renderer2,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  HostListener
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { fromEvent, BehaviorSubject, Observable, Subscription, of } from 'rxjs';
import { tap, map, debounceTime, filter, switchMap } from 'rxjs/operators';
import { WindowRef } from '@duoduo-oba/ng-devui/window-ref';
import { I18nService, I18nInterface } from '@duoduo-oba/ng-devui/i18n';
import { VerticalConnectionPos, ConnectedOverlayPositionChange, CdkOverlayOrigin, CdkConnectedOverlay } from '@angular/cdk/overlay';
import { fadeInOut } from '@duoduo-oba/ng-devui/utils';

@Component({
  selector: 'd-select',
  templateUrl: './select.component.html',
  styleUrls: [`./select.component.scss`],
  exportAs: 'select',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true
    }
  ],
  animations: [
    fadeInOut
  ]
})
export class SelectComponent implements ControlValueAccessor, OnInit, AfterViewInit, OnDestroy, OnChanges {

  get isOpen() {
    return this._isOpen;
  }

  set isOpen(value) {
    this._isOpen = value;
    this.toggleChange.emit(value);
    this.setDocumentClickListener();
  }
  /**
   * ãå¿éãä¸æéé¡¹èµæºï¼æ¯æArray<string>, Array<{key: value}>
   */
  @Input() options = [];
  /**
   * ãå¯éãæ¯å¦æ¯æè¿æ»¤æç´¢
   */
  @Input() isSearch = false;
  /**
   * ãå¯éãæ¯å¦æ¯æèç¦èªå¨å±å¼ä¸æ
   */
  @Input() toggleOnFocus = false;
  /**
   * ãå¯éãä¸æèåé«åº¦ï¼å»ºè®®ä½¿ç¨pxä½ä¸ºé«åº¦åä½
   */
  @Input() scrollHight = '300px';
  /**
   * ãå¯éãä¸æé«äº®css
   */
  @Input() hightLightItemClass = 'active';
  /**
   * ãå½ä¼ å¥èµæºï¼optionsï¼ç±»åä¸ºArray<{key: value}ï¼å¿éãéå¯¹ä¼ å¥èµæºoptionsçæ¯é¡¹å¯¹åºå­æ®µåè¿æ»¤æä½
   */
  @Input() filterKey: string;
  /**
   * ãå¯éãæ¯å¦æ¯æå¤é
   */
  @Input() multiple: boolean;
  /**
   * ãå¯éãæ¯å¦æ¯æå¨é
   */
  @Input() isSelectAll = false;
  /**
   * ãå¯éãæ¯å¦å¯ä»¥è¾å¥
   */
  @Input() readonly = true;
  /**
   * ãå¯éãä¸æéæ¡å°ºå¯¸
   */
  @Input() size: '' | 'sm' | 'lg';
  /**
   * ãå¯éãæ¯å¦appendToBody
   */
  @Input() appendToBody = false;
  /**
   * ãå¯éãcdkæ¨¡å¼origin width
   */
  @Input() width: number;
  /**
   * ãå¯éãæ¨¡æ¿é«åº¦
   */
  @Input() templateItemSize: number; // æ¨¡æ¿itemSizeï¼appendToBodyä¸ºtrue
  /**
   * ãå¯éãæ¯å¦ç¦ç¨ä¸ææ¡
   */
  @Input() disabled = false;
  /**
   * ãå¯éãä¸æé»è®¤æ¾ç¤ºæå­
   */
  @Input() placeholder = '';
  /**
   * ãå¯éãæç´¢å½æ°ï¼å½éè¦èªå®ä¹ä¸æéæ©è¿æ»¤è§åæ¶å¯ä»¥ä½¿ç¨
   *  è¯·ä¿è¯è¿åå¼æidåoptionå­æ®µï¼idæ¯ç¡®ä¿å°¤å¶å¤éçæ¶åè½æ­£ç¡®ç´¢å¼å¯¹åºéé¡¹
   *  ç®åå®ç°åèï¼
   *  search = (term) => {
   *    return of(
   *     [Lily, May, Jorsh, Shiwa, Nanth]
   *     .map((option, index) => ({id: index, option: option}))
   *     .filter(item => item.option.name.toLowerCase().indexOf(term.toLowerCase()) !== -1)
   *   );
   *  }
   */
  @Input() searchFn: (term: string) => Observable<Array<{ id: string | number; option: any }>>;
  /**
   * ãå¯éãå³å®éæ©æ¡æå­å¦ä½æ¾ç¤ºï¼é»è®¤æ¾ç¤ºfilterKeyå­æ®µæèæ¬èº«çå¼
   */
  @Input() valueParser: (item: any) => any;
  /**
   * ãå¯éãå³å®ä¸ææ¡æ²¡é¡¹æå­å¦ä½æ¾ç¤ºï¼é»è®¤æ¾ç¤ºfilterKeyå­æ®µæèæ¬èº«çå¼
   */
  @Input() formatter: (item: any) => string;
  @Input() direction: 'up' | 'down' | 'auto' = 'down';
  @Input() overview: 'border' | 'underlined' = 'border';

  /**
   *  ãå¯éãæ¯å¦å¼å¯clearåè½ï¼æ¯å¦å¼å¯åªå¯¹åéçæï¼
   */
  @Input() allowClear = false;

  get isClearIconShow () {
    return this.allowClear && !this.multiple && !this.disabled && this.value;
  }

  @Input() color;
  /**
   *  ãå¯éãå¯ç¨æ°æ®æå è½½ï¼é»è®¤ä¸å¯ç¨
   */
  @Input() enableLazyLoad = false;

  /**
   * æ¯å¦èææ»å¨
   */
  @Input() virtualScroll;

  /**
   * éå¿å¡«ï¼å¦ä¼ å¥ï¼ä¼å¿½ç¥ContentChild
   */
  @Input() inputItemTemplate: TemplateRef<any>;

  @ContentChild(TemplateRef, { static: false }) itemTemplate: TemplateRef<any>;

  /**
   * è¾åºå½æ°ï¼å½éä¸­æä¸ªéé¡¹é¡¹åï¼å°ä¼è°ç¨æ­¤å½æ°ï¼åæ°ä¸ºå½åéæ©é¡¹çå¼ãå¦æéè¦è·åææéæ©ç¶æçå¼ï¼è¯·åè(ngModelChange)æ¹æ³
   */
  @Output() valueChange = new EventEmitter();
  i18nCommonText: I18nInterface['common'];
  i18nSubscription: Subscription;
  /**
   * selectä¸ætoggleäºä»¶ï¼å¼ä¸ºtrueæfalse
   */
  @Output() toggleChange = new EventEmitter();

  @Output() loadMore = new EventEmitter();

  @Input() extraConfig: {
    labelization?: {
      // éä¸­é¡¹æ¾ç¤ºææ ç­¾ä¸æ ·ï¼å¸¦æå é¤æé®å¯ä»¥åä¸ªå é¤
      enable: boolean; // é»è®¤å¼ä¸ºfalse
      overflow?: 'normal' | 'scroll-y' | 'multiple-line' | string; // é»è®¤å¼ä¸º''
      containnerMaxHeight?: string; // é»è®¤å¼1.8em
      labelMaxWidth?: string; // é»è®¤100%
    };
    selectedItemWithTemplate?: {
      // åéæåµä¸ï¼æ¾ç¤ºéé¡¹ä½¿ç¨äºtemplateçæåµä¸ï¼é¡¶é¨éä¸­çåå®¹æ¯å¦ä¹ä»¥templateå±ç¤º
      enable: boolean; // é»è®¤å¼ä¸ºfalse
    };
    [featrue: string]: any;
  };

  /**
   * ãå½ä¼ å¥èµæºï¼optionsï¼ç±»åä¸ºArray<{key: value}ï¼å¿éãéå¯¹ä¼ å¥èµæºoptionsçæ¯é¡¹å¯¹åºå­æ®µåç¦ç¨æä½çkey
   */
  @Input() optionDisabledKey = '';
  /**
   * ãå½ä¼ å¥èµæºï¼optionsï¼ç±»åä¸ºArray<{key: value}ï¼å¿éãéå¯¹ä¼ å¥èµæºoptionsçæ¯é¡¹å¯¹åºå­æ®µç¦æ­¢åæ´çkey
   */
  @Input() optionImmutableKey = '';
  /**
   * ãå¯éãéç½®æ æ°æ®å±ç¤º
   */
  @Input() noResultItemTemplate: TemplateRef<any>;
  /**
   * ãå¯éãéç½®å¤éçæ¶åæ¯å¦ç»´æåæ°ç»æåºè¿æ¯ç¨æ·éæ©çé¡ºåºæåºï¼é»è®¤æ¯ç¨æ·é¡ºåº
   */
  @Input() keepMultipleOrder: 'origin' | 'user-select' = 'user-select';
  @Input() customViewTemplate: TemplateRef<any>;
  /**
   * customViewTemplateçæ¹åï¼æ¯æä¸æ¹åå³æ¹
   */
  @Input() customViewDirection: 'bottom' | 'right' = 'bottom';
  @Input() autoFocus = false;
  @Input() notAutoScroll = false; // èªå¨èç¦çæ¶åï¼èªå¨æ»å¨å°selectä½ç½®

  @ViewChild('selectInput', { static: false }) selectInputElement: ElementRef;
  @ViewChild('selectMenu', { static: false }) selectMenuElement: ElementRef;
  @ViewChild('selectBox', { static: true }) selectBoxElement: ElementRef;
  @ViewChild('selectInputWithTemplate', { static: false }) selectInputWithTemplateElement: ElementRef;
  @ViewChild('selectInputWithLabel', { static: false }) selectInputWithLabelElement: ElementRef;
  @ViewChild('filterInput', { static: false }) filterInputElement: ElementRef;
  @ViewChild('dropdownUl', { static: false }) dropdownUl: ElementRef;
  @ViewChild(CdkConnectedOverlay, { static: false }) connectedOverlay: CdkConnectedOverlay;

  showLoading = false;
  _isOpen = false;
  menuPosition: VerticalConnectionPos = 'bottom';
  halfChecked = false;
  allChecked = false;
  isMouseEvent = false;

  filter = '';
  activeIndex = -1;

  // for multiple
  availableOptions = [];
  multiItems = [];

  popDirection: 'top' | 'bottom';

  selectIndex = -1;
  _inputValue: any;
  virtualScrollItemSize: any = { // små¯¹åºæ¯30pxï¼é»è®¤36pxé«ï¼lgå¯¹åºæ¯44px
    sm: 30,
    normal: 36,
    lg: 44
  };

  cdkConnectedOverlayOrigin: CdkOverlayOrigin;

  private sourceSubscription: BehaviorSubject<any>;
  private filterSubscription: Subscription;
  public value;
  private resetting = false;

  private onChange = (_: any) => null;
  private onTouch = () => null;
  constructor(
    private renderer: Renderer2,
    private windowRef: WindowRef,
    private changeDetectorRef: ChangeDetectorRef,
    private i18n: I18nService,
    private ngZone: NgZone
  ) {
    this.valueParser = item => (typeof item === 'object' ? item[this.filterKey] || '' : (item + '') ? item.toString() : '');
    this.formatter = item => (typeof item === 'object' ? item[this.filterKey] || '' : (item + '') ? item.toString() : '');
  }

  ngOnInit(): void {
    if (!this.searchFn) {
      this.searchFn = (term: any) => {
        return of(
          (this.options ? this.options : [])
            .map((option, index) => ({ option: option, id: index }))
            .filter(
              item =>
                this.formatter(item.option)
                  .toLowerCase()
                  .indexOf(term.toLowerCase()) !== -1
            )
        );
      };
    }
    // åªæå¤éçæåµisSelectAllä¸ºtrueæææä¹
    if (!this.multiple) {
      this.isSelectAll = false;
    }
    this.setI18nText();
    this.registerFilterChange();
  }

  ngAfterViewInit() {
    if (this.autoFocus && this.selectBoxElement) {
      this.selectBoxElement.nativeElement.focus({
        preventScroll: this.notAutoScroll
      });
    }

    if (this.selectBoxElement) {
      this.width = this.width ? this.width : this.selectBoxElement.nativeElement.offsetWidth;
    }
  }

  ngOnDestroy(): void {
    if (this.sourceSubscription) {
      this.sourceSubscription.unsubscribe();
    }
    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }
    if (this.i18nSubscription) {
      this.i18nSubscription.unsubscribe();
    }
    document.removeEventListener('click', this.onDocumentClick);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && (changes.searchFn || changes.options)) {
      this.resetSource();
    }
  }

  setI18nText() {
    this.i18nCommonText = this.i18n.getI18nText().common;
    this.i18nSubscription = this.i18n.langChange().subscribe((data) => {
      this.i18nCommonText = data.common;
    });
  }

  getVirtualScrollHeight(len, size) {
    if (len > 0) {
      let height = this.templateItemSize ? this.templateItemSize * len : this.virtualScrollItemSize[size ? size : 'normal'] * len;
      if (this.isSelectAll && this.multiple) {
        height += this.virtualScrollItemSize[size ? size : 'normal'];
      }
      const scrollHight = parseInt(this.scrollHight, 10);
      if (height > scrollHight) {
        return this.scrollHight;
      } else {
        return height + 'px';
      }
    }
  }

  getVirtualScrollItemSize(size) {
    return this.templateItemSize ? this.templateItemSize : this.virtualScrollItemSize[size ? size : 'normal'];
  }

  resetSource() {
    if (this.sourceSubscription && this.searchFn) {
      this.resetting = true;
      this.sourceSubscription.next('');
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  registerFilterChange(): void {
    this.sourceSubscription = new BehaviorSubject<any>('');
    this.sourceSubscription.pipe(switchMap(term => this.searchFn(term))).subscribe(options => {
      this.availableOptions = options;
      this.setAvailableOptions();
      this.changeDetectorRef.markForCheck();
      if (this.appendToBody) {
        setTimeout(() => {
          if (this.connectedOverlay && this.connectedOverlay.overlayRef) {
            this.connectedOverlay.overlayRef.updatePosition();
          }
        });
      }
       // æ¾ç¤ºæ°æ®åæ´ï¼éè¦å¤æ­å¨éåéç¶æ
      if (this.isSelectAll) {
          const selectedItemForFilterOptions = [];
          this.multiItems.forEach(item => {
          this.availableOptions.forEach(option => {
             if (item['id'] === option['id']) {
              selectedItemForFilterOptions.push(item);
             }
            });
          });
          this.setChecked(selectedItemForFilterOptions);
      }
      if (!this.multiple && (!this.value || this.availableOptions && !this.availableOptions.find(option => option.option === this.value))) {
        this.selectIndex = this.availableOptions && this.availableOptions.length > 0 ? 0 : -1;
      }
    });

    this.sourceSubscription.subscribe(term => {
      if (this.resetting && term === '') {
        this.writeValue(this.value);
        this.resetting = false;
      }
    });

    this.searchInputValueChangeEvent();
  }

  searchInputValueChangeEvent() {
    if (this.isSearch && this.isOpen && this.filterInputElement) {
      this.filterInputElement.nativeElement.focus();
      if (!this.filterSubscription || this.appendToBody) { // é¿åéå¤è®¢é
        this.filterSubscription = fromEvent(this.filterInputElement.nativeElement, 'input')
        .pipe(
          map((e: any) => e.target.value),
          tap(term => this.onTouch()),
          filter(term => !this.disabled && this.searchFn && term.length >= 0),
          debounceTime(300) // hard code need refactory
        )
        .subscribe(term => {
          this.filter = term;
          this.selectIndex = -1;
          return this.sourceSubscription.next(term);
        });
      }
    }
  }

  writeValue(obj: any): void {
    if (obj === null || obj === undefined) {
      return;
    }
    this.value = obj;

    if (this.multiple) {
      this.value = this.value ? this.value : [];
      this.value = Array.isArray(this.value) ? this.value : [this.value];
      this.multiItems = this.value.map((option, index) => ({ option: option, id: this.options.indexOf(option) }));
    } else {
      const selectedItem = this.availableOptions.find(
        item => this.formatter(item.option) === this.formatter(this.value)
      );
      this.activeIndex = selectedItem ? selectedItem.id : -1;
      this.selectIndex = this.activeIndex ? this.activeIndex : -1;
    }

    this.writeIntoInput(this.value);
    this.changeDetectorRef.markForCheck();
    this.setChecked(this.value);
  }

  writeIntoInput(value): void {
    this._inputValue = this.multiple
      ? (value || []).map(option => this.valueParser(option)).join(', ')
      : this.valueParser(value);
    this.setAvailableOptions();
  }

  setAvailableOptions() {
    if (!this.value || !Array.isArray(this.availableOptions)) {
      return;
    }
    let _value = this.value;
    if (!this.multiple) {
      _value = [_value];
    }
    this.availableOptions = this.availableOptions
      .map((item) => ({
        isChecked: _value.findIndex(i => JSON.stringify(i) === JSON.stringify(item.option)) > -1, id: item.id, option: item.option
      }));
  }

  choose = (option, index, $event?: Event) => {
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }

    if (typeof option === 'object') {
      if (Object.keys(option).length === 0 || this.disabled) {
        this.isOpen = false;
        return;
      }
    } else {
      if (this.disabled) {
        this.isOpen = false;
        return;
      }
    }

    if (this.optionDisabledKey && option[this.optionDisabledKey]) {
      return;
    }
    if (this.optionImmutableKey && option[this.optionImmutableKey]) {
      return;
    }

    if (this.multiple) {
      const indexOfOption = this.multiItems.findIndex(item => JSON.stringify(item.option) === JSON.stringify(option));
      if (indexOfOption === -1) {
        this.multiItems.push({ id: index, option });
      } else {
        this.multiItems.splice(indexOfOption, 1);
      }
      if (this.keepMultipleOrder === 'origin') {
        this.multiItems.sort((a, b) => a.id - b.id);
      }
      this.value = this.multiItems.map(item => item.option);
    } else {
      this.value = option;
      this.activeIndex = index;
      this.selectIndex = index;
      this.toggle();
    }
    this.writeIntoInput(this.value);
    this.onChange(this.value);
    this.valueChange.emit(option);
    this.setChecked(this.value);
  }

  updateCdkConnectedOverlayOrigin() {
    if (this.selectBoxElement.nativeElement) {
      this.cdkConnectedOverlayOrigin = new CdkOverlayOrigin(this.selectBoxElement.nativeElement);
    }
  }

  autoToggle($event) {
    $event.preventDefault();
    $event.stopPropagation();
    if (this.toggleOnFocus && !this.disabled && !this.isOpen && !this.isMouseEvent) {
      this.toggle();
    }
  }

  // mousedown mouseupè§£å³focusä¸clickå²çªé®é¢
  @HostListener('mousedown', ['$event'])
  public setMouseEventTrue(event) {
    this.isMouseEvent = true;
  }
  @HostListener('mouseup', ['$event'])
  public setMouseEventFalse(event) {
    this.isMouseEvent = false;
  }

  toggle() {
    if (this.disabled) {
      this.isOpen = false;
      return;
    }

    if (!this.isOpen) {
      this.filter = '';
      this.resetSource();

      if (!this.appendToBody) {
        let direction = '';
        switch (this.direction) {
          case 'auto':
            direction = this.isBottomRectEnough() ? 'bottom' : 'top';
            break;
          case 'down':
            direction = 'bottom';
            break;
          case 'up':
            direction = 'top';
            break;
          default:
            direction = 'bottom';
        }
        this.popDirection = <any>direction;
      } else {
        this.updateCdkConnectedOverlayOrigin();
      }
    }
    this.isOpen = !this.isOpen;

    const that = this;
    setTimeout(function () {
      that.searchInputValueChangeEvent();
    }, 100);
  }

  isBottomRectEnough() {
    const selectMenuElement = this.selectMenuElement.nativeElement;
    const selectInputElement = this.selectInputElement || this.selectInputWithLabelElement || this.selectInputWithTemplateElement;
    const displayStyle =
      selectMenuElement.style['display'] || (<any>window).getComputedStyle(selectMenuElement).display;
    let tempStyle;
    if (displayStyle === 'none') { // å¿è¦ï¼ å¦åé¦æ¬¡å±å¼å¿æé®é¢ï¼ å¦æanimationEndä¹åè®¾ç½®ä¸ºnoneä¹ä¼æé®é¢
      tempStyle = {
        visibility: selectMenuElement.style.visibility,
        display: selectMenuElement.style.display,
        transform: selectMenuElement.style.transform,
      };
      this.renderer.setStyle(selectMenuElement, 'visibility', 'hidden');
      this.renderer.setStyle(selectMenuElement, 'display', 'block');
      this.renderer.setStyle(selectMenuElement, 'transform', 'translate(0, -9999)');
    }
    const elementHeight = selectMenuElement.offsetHeight;
    const bottomDistance =
      this.windowRef.innerHeight - selectInputElement.nativeElement.getBoundingClientRect().bottom;
    const isBottomEnough = bottomDistance >= elementHeight;
    if (displayStyle === 'none') {
      this.renderer.setStyle(selectMenuElement, 'visibility', tempStyle.visibility);
      this.renderer.setStyle(selectMenuElement, 'display', tempStyle.display);
      this.renderer.setStyle(selectMenuElement, 'transform', tempStyle.transform);
    }
    return isBottomEnough;
  }

  setDocumentClickListener() {
    this.ngZone.runOutsideAngular(() => {
      if (this.isOpen) {
        document.addEventListener('click', this.onDocumentClick);
      } else {
        document.removeEventListener('click', this.onDocumentClick);
      }
    });
  }

  onDocumentClick = ($event: Event) => {
    if (this.isOpen && !this.selectBoxElement.nativeElement.contains($event.target)) {
      this.isOpen = false;
      this.selectIndex = this.activeIndex ? this.activeIndex : -1;
      this.changeDetectorRef.detectChanges();
    }
  }

  onEscKeyup($event) {
    if (this.isOpen) {
      $event.stopPropagation();
    }
    this.isOpen = false;
  }

  handleKeyUpEvent($event) {
    if (this.isOpen) {
      $event.preventDefault();
      $event.stopPropagation();
      this.selectIndex = this.selectIndex === 0 || this.selectIndex === -1 ? this.availableOptions.length - 1 : this.selectIndex - 1;
      this.scrollToActive();
    }
  }

  handleKeyDownEvent($event) {
    if (this.isOpen) {
      $event.preventDefault();
      $event.stopPropagation();
      this.selectIndex =
        this.selectIndex === this.availableOptions.length - 1 ? 0 : this.selectIndex + 1;
      this.scrollToActive();
    }
  }

  scrollToActive(): void {
    const that = this;
    setTimeout(_ => {
      try {
        const selectIndex = that.selectIndex + (that.isSelectAll ? 1 : 0); // å¤äºä¸ªå¨éä¼å¯¼è´é®é¢ï¼indexéè¦å 1
        const scrollPane: any = that.dropdownUl.nativeElement.children[selectIndex];
        if (scrollPane.scrollIntoViewIfNeeded) {
          scrollPane.scrollIntoViewIfNeeded(false);
        } else {
          const containerInfo = that.dropdownUl.nativeElement.getBoundingClientRect();
          const elementInfo = scrollPane.getBoundingClientRect();
          if (elementInfo.bottom > containerInfo.bottom || elementInfo.top < containerInfo.top) {
            scrollPane.scrollIntoView(false);
          }
        }
      } catch (e) {
      }
    });
  }

  handleKeyEnterEvent($event) {
    if (this.isOpen) {
      $event.preventDefault();
      $event.stopPropagation();
      const item = this.availableOptions[this.selectIndex];
      if (item) {
        this.choose(item.option, item.id, $event);
      } else {
        this.toggle();
      }
    } else {
      this.toggle();
    }
  }

  removeItem(item, $event) {
    this.choose(item.option, item.id, $event);
  }

  selectAll() {
    const mutableOption = this.optionImmutableKey
      ? this.availableOptions.filter(item => !item.option[this.optionImmutableKey])
      : this.availableOptions;
    const selectedImmutableOption = this.optionImmutableKey
      ? this.multiItems.filter(item => item.option[this.optionImmutableKey])
      : [];

    if (mutableOption && mutableOption.length > (this.multiItems.length - selectedImmutableOption.length)) {
      mutableOption.map(item => {
        const indexOfOption = this.multiItems
          .findIndex(i => JSON.stringify(i.option) === JSON.stringify(item.option));
        if (indexOfOption === -1) {
          this.multiItems.push({ id: item.id, option: item.option });
        }
      });
    } else {
      this.multiItems = [...selectedImmutableOption];
    }
    this.value = this.multiItems.map(item => item.option);
    this.writeIntoInput(this.value);
    this.onChange(this.value);
    this.valueChange.emit(this.multiItems);
    this.setChecked(this.value);
  }

  trackByFn(index, item) {
    return index;
  }

  trackByOptionPointer(index, item) {
    return item.option;
  }

  loadMoreEvent(event) {
    this.showLoading = true;
    this.loadMore.emit({ instance: this, event: event });
  }

  loadFinish() {
    this.showLoading = false;
    this.changeDetectorRef.markForCheck();
  }

  loadStart() {
    this.showLoading = true;
  }

  onPositionChange(position: ConnectedOverlayPositionChange) {
    this.menuPosition = position.connectionPair.originY;
  }

  animationEnd($event) {
    if (!this.isOpen && this.selectMenuElement) {
      const targetElement = this.selectMenuElement.nativeElement;
      setTimeout(() => {
        // å¨ç»ä¼è¦çå¯¼è´displayè¿æ¯blockï¼ æä»¥è¦ç­å¨ç»è¦çå®
        this.renderer.setStyle(targetElement, 'display', 'none');
      });
    }
  }

  setChecked(selectedItem) {
    if (!selectedItem) {
      return;
    }
    if (!this.isSelectAll) {
      return;
    }
    this.halfChecked = false;
    if (selectedItem.length === this.availableOptions.length) {
      this.allChecked = true;
    } else if (selectedItem.length === 0) {
      this.allChecked = false;
    } else {
      this.halfChecked = true;
    }
  }

  showSelectAll() {
    return this.isSelectAll && this.multiple && this.availableOptions.length > 0;
  }

  public forceSearchNext() {
    this.sourceSubscription.next(this.filter);
  }

  valueClear($event) {
    $event.stopPropagation();
    this.value = null;
    this.resetStatus();
    this.onChange(this.value);
    this.valueChange.emit(this.value);
  }

  resetStatus() {
    this.writeIntoInput('');
    this.activeIndex = -1;
    this.selectIndex  = -1;
    this.changeDetectorRef.markForCheck();
  }
}
